-- combat.sql – combat.qc and the projectiles: gibs, Killed, T_Damage, T_RadiusDamage, the
-- spikes, grenades and rockets, and SV_Impact's touches.

SET TERM ^ ;

-- ── damage (combat.qc) ───────────────────────────────────────────────────
-- VelocityForDamage(dm), dm the (negative) health: 100 crandom() across each way, 200 + 100 random() up, all × 0.7
-- above -50, × 2 above -200, else × 10
CREATE OR ALTER PROCEDURE velocity_for_damage (dm INTEGER)
RETURNS (vx DOUBLE PRECISION, vy DOUBLE PRECISION, vz DOUBLE PRECISION)
AS
DECLARE k DOUBLE PRECISION;
BEGIN
  vx = 100 * (2 * (rnd() - 0.5e0)); vy = 100 * (2 * (rnd() - 0.5e0)); vz = 200 + 100 * rnd();
  k = IIF(dm > -50, 0.7e0, IIF(dm > -200, 2, 10));
  vx = vx * k; vy = vy * k; vz = vz * k;
END^

-- ThrowGib: a gib from the origin, VelocityForDamage, spun by three random()s (the yaw's kept), gone 10 to 20 s on
-- (dmg: the damage below zero, -health)
CREATE OR ALTER PROCEDURE throw_gib (eid INTEGER, model VARCHAR(64), dmg INTEGER)
AS
DECLARE g INTEGER; DECLARE vx DOUBLE PRECISION; DECLARE vy DOUBLE PRECISION; DECLARE vz DOUBLE PRECISION; DECLARE ay DOUBLE PRECISION;
DECLARE r DOUBLE PRECISION;
BEGIN
  EXECUTE PROCEDURE spawn_ent('gib', (SELECT e.x FROM ents e WHERE e.id = :eid), (SELECT e.y FROM ents e WHERE e.id = :eid),
    (SELECT e.z FROM ents e WHERE e.id = :eid)) RETURNING_VALUES g;
  EXECUTE PROCEDURE set_model(g, model);
  EXECUTE PROCEDURE velocity_for_damage(-dmg) RETURNING_VALUES vx, vy, vz;
  r = rnd(); ay = rnd() * 600; r = rnd();
  UPDATE ents e SET e.movetype = 10, e.solid = 0, e.minx = 0, e.miny = 0, e.minz = 0, e.maxx = 0, e.maxy = 0, e.maxz = 0,
         e.vx = :vx, e.vy = :vy, e.vz = :vz, e.avel_yaw = :ay, e.think = 'remove', e.nextthink = now_() + 10 + rnd() * 10, e.frame = 0
   WHERE e.id = :g;
END^

-- ThrowHead: the body becomes its head, 24 lower, VelocityForDamage, spun by crandom() × 600 about the vertical
CREATE OR ALTER PROCEDURE throw_head (eid INTEGER, model VARCHAR(64), dmg INTEGER)
AS
DECLARE vx DOUBLE PRECISION; DECLARE vy DOUBLE PRECISION; DECLARE vz DOUBLE PRECISION;
BEGIN
  EXECUTE PROCEDURE set_model(eid, model);
  EXECUTE PROCEDURE velocity_for_damage(-dmg) RETURNING_VALUES vx, vy, vz;
  UPDATE ents e SET e.movetype = 10, e.solid = 0, e.takedamage = 0, e.frame = 0, e.anim = NULL, e.st = 'dead',
         e.minx = -16, e.miny = -16, e.minz = 0, e.maxx = 16, e.maxy = 16, e.maxz = 56, e.z = e.z - 24,
         e.vx = :vx, e.vy = :vy, e.vz = :vz, e.avel_yaw = 2 * (rnd() - 0.5e0) * 600, e.think = NULL, e.nextthink = NULL,
         e.flags = BIN_AND(e.flags, BIN_NOT(512)) WHERE e.id = :eid;
END^

-- Killed(): the target's health fell to zero
CREATE OR ALTER PROCEDURE killed (targ INTEGER, attacker INTEGER)
AS
DECLARE cls VARCHAR(40); DECLARE flags INTEGER; DECLARE hp INTEGER; DECLARE mt SMALLINT; DECLARE r DOUBLE PRECISION;
BEGIN
  SELECT e.classname, e.flags, e.health, e.movetype FROM ents e WHERE e.id = :targ INTO cls, flags, hp, mt;
  IF (hp < -99) THEN UPDATE ents e SET e.health = -99 WHERE e.id = :targ;
  -- ClientObituary's random() (drawn first, whoever died; not for a pusher or a thing that does not move, whose
  -- th_die comes at once)
  IF (mt NOT IN (0, 7)) THEN r = rnd();
  IF (cls = 'player') THEN
  BEGIN
    UPDATE ents e SET e.deadflag = 1, e.solid = 0, e.movetype = 6, e.minz = -24, e.maxz = -8, e.takedamage = 0,
           e.anim = 'death' || SUBSTRING('abcde' FROM 1 + FLOOR(rnd() * 5) FOR 1), e.anim_frame = 0 WHERE e.id = :targ;
    UPDATE player p SET p.dead_time = now_(), p.view_ofs = -8, p.weapon = 0, p.items = BIN_AND(p.items, BIN_NOT(1048576 + 524288 + 4194304 + 2097152)) WHERE p.id = 1;
    -- DeathSound: under water five bubbles and h2odeath
    IF ((SELECT e.waterlevel FROM ents e WHERE e.id = :targ) = 3) THEN
    BEGIN
      EXECUTE PROCEDURE death_bubbles(targ, 5);
      EXECUTE PROCEDURE snd(targ, 2, 'player/h2odeath.wav', 1, 0);
    END
    ELSE EXECUTE PROCEDURE snd(targ, 2, 'player/death' || CAST(1 + FLOOR(rnd() * 5) AS INTEGER) || '.wav', 1, 1);
    EXIT;
  END
  IF (BIN_AND(flags, 32) <> 0) THEN
  BEGIN
    EXECUTE PROCEDURE monster_die(targ, attacker);
    EXIT;
  END
  IF (cls = 'misc_explobox') THEN
  BEGIN
    EXECUTE PROCEDURE t_radius_damage(targ, attacker, 160, NULL);
    EXECUTE PROCEDURE snd(targ, 0, 'weapons/r_exp3.wav', 1, 1);
    EXECUTE PROCEDURE fx(2, (SELECT e.x + (e.minx + e.maxx) / 2 FROM ents e WHERE e.id = :targ), (SELECT e.y + (e.miny + e.maxy) / 2 FROM ents e WHERE e.id = :targ),
      (SELECT e.z + (e.minz + e.maxz) / 2 FROM ents e WHERE e.id = :targ), 0, 0, 0, 0);
    DELETE FROM ents e WHERE e.id = :targ;
    EXIT;
  END
  -- shootable doors, buttons and triggers
  IF (cls = 'func_door') THEN
  BEGIN
    UPDATE ents e SET e.takedamage = 0, e.health = e.max_health WHERE e.id = :targ;
    EXECUTE PROCEDURE door_fire(targ, attacker);
  END
  ELSE IF (cls = 'func_door_secret') THEN EXECUTE PROCEDURE secret_use(targ);
  ELSE IF (cls = 'func_button') THEN
  BEGIN
    UPDATE ents e SET e.takedamage = 0 WHERE e.id = :targ;
    EXECUTE PROCEDURE button_fire(targ, attacker);
  END
  ELSE IF (cls IN ('trigger_multiple', 'trigger_once')) THEN
  BEGIN
    UPDATE ents e SET e.takedamage = 0 WHERE e.id = :targ;
    EXECUTE PROCEDURE trigger_fire(targ, attacker);
  END
END^

-- T_Damage
-- (the damage is a fraction, as in T_Damage: the push takes it whole, the armor and health its ceiling)
CREATE OR ALTER PROCEDURE t_damage (targ INTEGER, inflictor INTEGER, attacker INTEGER, damage DOUBLE PRECISION)
AS
DECLARE td SMALLINT; DECLARE cls VARCHAR(40); DECLARE flags INTEGER; DECLARE hp INTEGER;
DECLARE save INTEGER; DECLARE take INTEGER; DECLARE av INTEGER; DECLARE atype DOUBLE PRECISION; DECLARE inv DOUBLE PRECISION;
DECLARE dx DOUBLE PRECISION; DECLARE dy DOUBLE PRECISION; DECLARE dz DOUBLE PRECISION; DECLARE dl DOUBLE PRECISION;
DECLARE mt SMALLINT; DECLARE acls VARCHAR(40); DECLARE pe INTEGER; DECLARE sdf DOUBLE PRECISION; DECLARE pf DOUBLE PRECISION;
DECLARE cur INTEGER; DECLARE pwf INTEGER; DECLARE pinv DOUBLE PRECISION; DECLARE paxe SMALLINT; DECLARE pwl SMALLINT; DECLARE pwt INTEGER;
BEGIN
  SELECT e.takedamage, e.classname, e.flags, e.health, e.movetype FROM ents e WHERE e.id = :targ INTO td, cls, flags, hp, mt;
  IF (td IS NULL OR td = 0 OR hp <= 0 AND cls <> 'player') THEN EXIT;
  pe = player_ent();
  SELECT e.classname FROM ents e WHERE e.id = :attacker INTO acls;
  IF (attacker = pe) THEN
  BEGIN
    SELECT p.super_damage_finished FROM player p WHERE p.id = 1 INTO sdf;
    IF (sdf > now_()) THEN damage = damage * 4;
  END
  save = 0;
  IF (cls = 'player') THEN
  BEGIN
    SELECT p.armorvalue, p.armortype, p.invincible_finished FROM player p WHERE p.id = 1 INTO av, atype, inv;
    save = CEILING(atype * damage);
    IF (save >= av) THEN
    BEGIN
      save = av;
      UPDATE player p SET p.armortype = 0, p.items = BIN_AND(p.items, BIN_NOT(8192 + 16384 + 32768)) WHERE p.id = 1;
    END
    UPDATE player p SET p.armorvalue = p.armorvalue - :save, p.dmg_take = p.dmg_take + CEILING(:damage - :save), p.dmg_save = p.dmg_save + :save, p.dmg_time = now_() WHERE p.id = 1;
    -- the inflictor's middle, for the view kick (SV_WriteClientdataToMessage: dmg_inflictor's origin + its box's
    -- middle; the world's is the level's middle)
    IF (inflictor IS NOT NULL AND inflictor > 0 AND EXISTS (SELECT 1 FROM ents e WHERE e.id = :inflictor)) THEN
    BEGIN
      SELECT e.x + (e.minx + e.maxx) / 2, e.y + (e.miny + e.maxy) / 2, e.z + (e.minz + e.maxz) / 2 FROM ents e WHERE e.id = :inflictor INTO dx, dy, dz;
      UPDATE player p SET p.dmg_ent = :inflictor, p.dmg_x = :dx, p.dmg_y = :dy, p.dmg_z = :dz WHERE p.id = 1;
    END
    ELSE
    BEGIN
      SELECT (m.minx + m.maxx) / 2, (m.miny + m.maxy) / 2, (m.minz + m.maxz) / 2 FROM models m
       WHERE m.id = (SELECT g.world_model FROM game g WHERE g.id = 1) INTO dx, dy, dz;
      UPDATE player p SET p.dmg_ent = 0, p.dmg_x = :dx, p.dmg_y = :dy, p.dmg_z = :dz WHERE p.id = 1;
    END
  END
  take = CEILING(damage - save);

  -- add to the damage momentum of the entity
  IF (inflictor IS NOT NULL AND inflictor > 0 AND mt = 3) THEN
  BEGIN
    SELECT e1.x - (e2.x + (e2.minx + e2.maxx) / 2), e1.y - (e2.y + (e2.miny + e2.maxy) / 2), e1.z - (e2.z + (e2.minz + e2.maxz) / 2)
      FROM ents e1 CROSS JOIN ents e2 WHERE e1.id = :targ AND e2.id = :inflictor INTO dx, dy, dz;
    dl = vlen(dx, dy, dz);
    IF (dl > 0) THEN
      UPDATE ents e SET e.vx = e.vx + :dx / :dl * :damage * 8, e.vy = e.vy + :dy / :dl * :damage * 8, e.vz = e.vz + :dz / :dl * :damage * 8 WHERE e.id = :targ;
  END

  -- god mode and invulnerability, only now (T_Damage: the armor is spent and the push given first: a rocket jump
  -- in god mode still flies); the invulnerability's sound every 2 s at most (its own timer)
  IF (BIN_AND(flags, 64) <> 0) THEN EXIT;
  IF (cls = 'player' AND inv >= now_()) THEN
  BEGIN
    IF ((SELECT p.invincible_sound FROM player p WHERE p.id = 1) < now_()) THEN
    BEGIN
      EXECUTE PROCEDURE snd(targ, 3, 'items/protect3.wav', 1, 1);
      UPDATE player p SET p.invincible_sound = now_() + 2 WHERE p.id = 1;
    END
    EXIT;
  END

  UPDATE ents e SET e.health = e.health - :take WHERE e.id = :targ RETURNING e.health INTO hp;
  IF (hp <= 0) THEN
  BEGIN
    EXECUTE PROCEDURE killed(targ, attacker);
    EXIT;
  END
  IF (cls = 'player') THEN
  BEGIN
    -- player_pain: nothing while the weapon's frames run or while invisible; else PainSound: under water a bubble
    -- (DeathBubbles(1)) and drown1 or drown2, in slime or lava lburn1 or lburn2, each hurt; else at most every 0.5 s
    -- (pain_finished), the axe's thud if a grunt's axe hit (axhitme), else pain1 to pain6 by rint(random() × 5 + 1).
    -- (No view kick: player_pain has none)
    SELECT p.pain_finished, p.weaponframe, p.invisible_finished, p.axhitme FROM player p WHERE p.id = 1 INTO pf, pwf, pinv, paxe;
    SELECT e.waterlevel, e.watertype FROM ents e WHERE e.id = :targ INTO pwl, pwt;
    IF (pwf = 0 AND pinv <= now_()) THEN
    BEGIN
      IF (pwt = -3 AND pwl = 3) THEN
      BEGIN
        EXECUTE PROCEDURE death_bubbles(targ, 1);
        EXECUTE PROCEDURE snd(targ, 2, TRIM(IIF(rnd() > 0.5e0, 'player/drown1.wav', 'player/drown2.wav')), 1, 1);
      END
      ELSE IF (pwt = -4 OR pwt = -5) THEN
        EXECUTE PROCEDURE snd(targ, 2, TRIM(IIF(rnd() > 0.5e0, 'player/lburn1.wav', 'player/lburn2.wav')), 1, 1);
      ELSE IF (pf > now_()) THEN
        UPDATE player p SET p.axhitme = 0 WHERE p.id = 1 AND p.axhitme <> 0;
      ELSE
      BEGIN
        UPDATE player p SET p.pain_finished = now_() + 0.5e0 WHERE p.id = 1;
        IF (paxe = 1) THEN
        BEGIN
          UPDATE player p SET p.axhitme = 0 WHERE p.id = 1;
          EXECUTE PROCEDURE snd(targ, 2, 'player/axhit1.wav', 1, 1);
        END
        ELSE EXECUTE PROCEDURE snd(targ, 2, 'player/pain' || CAST(ROUND(rnd() * 5 + 1) AS INTEGER) || '.wav', 1, 1);
      END
    END
    -- (T_Damage after th_pain: on nightmare the player's next pain waits 5 s too)
    IF (nightmare() = 1) THEN UPDATE player p SET p.pain_finished = now_() + 5 WHERE p.id = 1;
    EXIT;
  END
  IF (BIN_AND(flags, 32) <> 0) THEN
  BEGIN
    -- T_Damage: get mad at whoever hurt us (not the world, not ourselves, not the enemy we have), unless
    -- it is one of our own kind, except for soldiers; a monster fighting another remembers the player
    SELECT e.enemy_id FROM ents e WHERE e.id = :targ INTO cur;
    IF (attacker IS NOT NULL AND attacker > 0 AND attacker <> targ AND attacker IS DISTINCT FROM cur
        AND (cls IS DISTINCT FROM acls OR cls = 'monster_army')) THEN
    BEGIN
      IF (cur = pe) THEN UPDATE ents e SET e.oldenemy_id = :pe WHERE e.id = :targ;
      EXECUTE PROCEDURE found_target(targ, attacker);
    END
    EXECUTE PROCEDURE monster_pain(targ, attacker, take);
    -- nightmare mode monsters don't go into pain frames often
    IF (nightmare() = 1) THEN UPDATE ents e SET e.pain_finished = now_() + 5 WHERE e.id = :targ;
  END
END^

-- CanDamage: can the inflictor's origin reach targ? A brush model by the middle of its bounds (or the line ending on
-- it), anything else by its origin or one of four points 15 units off it across (lines that pass monsters)
CREATE OR ALTER FUNCTION can_damage (targ INTEGER, inflictor INTEGER) RETURNS SMALLINT
AS
DECLARE ix DOUBLE PRECISION; DECLARE iy DOUBLE PRECISION; DECLARE iz DOUBLE PRECISION;
DECLARE ox DOUBLE PRECISION; DECLARE oy DOUBLE PRECISION; DECLARE oz DOUBLE PRECISION;
DECLARE cx DOUBLE PRECISION; DECLARE cy DOUBLE PRECISION; DECLARE cz DOUBLE PRECISION; DECLARE mt SMALLINT;
DECLARE f DOUBLE PRECISION; DECLARE ex DOUBLE PRECISION; DECLARE ey DOUBLE PRECISION; DECLARE ez DOUBLE PRECISION;
DECLARE nx DOUBLE PRECISION; DECLARE ny DOUBLE PRECISION; DECLARE nz DOUBLE PRECISION;
DECLARE als SMALLINT; DECLARE sts SMALLINT; DECLARE io SMALLINT; DECLARE iw SMALLINT; DECLARE hit INTEGER; DECLARE k INTEGER = 0;
BEGIN
  SELECT e.x, e.y, e.z FROM ents e WHERE e.id = :inflictor INTO ix, iy, iz;
  SELECT e.x, e.y, e.z, e.x + (e.minx + e.maxx) / 2, e.y + (e.miny + e.maxy) / 2, e.z + (e.minz + e.maxz) / 2, e.movetype
    FROM ents e WHERE e.id = :targ INTO ox, oy, oz, cx, cy, cz, mt;
  IF (ix IS NULL OR ox IS NULL) THEN RETURN 0;
  IF (mt = 7) THEN
  BEGIN
    EXECUTE PROCEDURE trace_move(inflictor, 0, 0, 0, 0, 0, 0, ix, iy, iz, cx, cy, cz, 1)
      RETURNING_VALUES f, ex, ey, ez, nx, ny, nz, als, sts, io, iw, hit;
    RETURN IIF(f = 1 OR hit = targ, 1, 0);
  END
  WHILE (k < 5) DO
  BEGIN
    EXECUTE PROCEDURE trace_move(inflictor, 0, 0, 0, 0, 0, 0, ix, iy, iz,
        ox + DECODE(k, 1, 15, 2, -15, 3, -15, 4, 15, 0), oy + DECODE(k, 1, 15, 2, -15, 3, 15, 4, -15, 0), oz, 1)
      RETURNING_VALUES f, ex, ey, ez, nx, ny, nz, als, sts, io, iw, hit;
    IF (f = 1) THEN RETURN 1;
    k = k + 1;
  END
  RETURN 0;
END^

-- T_RadiusDamage
CREATE OR ALTER PROCEDURE t_radius_damage (inflictor INTEGER, attacker INTEGER, damage INTEGER, ignore INTEGER)
AS
DECLARE ix DOUBLE PRECISION; DECLARE iy DOUBLE PRECISION; DECLARE iz DOUBLE PRECISION;
DECLARE eid INTEGER; DECLARE d DOUBLE PRECISION; DECLARE pts DOUBLE PRECISION;
DECLARE f DOUBLE PRECISION; DECLARE ex DOUBLE PRECISION; DECLARE ey DOUBLE PRECISION; DECLARE ez DOUBLE PRECISION;
DECLARE nx DOUBLE PRECISION; DECLARE ny DOUBLE PRECISION; DECLARE nz DOUBLE PRECISION;
DECLARE als SMALLINT; DECLARE sts SMALLINT; DECLARE io SMALLINT; DECLARE iw SMALLINT; DECLARE hit INTEGER;
DECLARE cx DOUBLE PRECISION; DECLARE cy DOUBLE PRECISION; DECLARE cz DOUBLE PRECISION;
DECLARE ox DOUBLE PRECISION; DECLARE oy DOUBLE PRECISION; DECLARE oz DOUBLE PRECISION;
DECLARE mt SMALLINT; DECLARE cls VARCHAR(40); DECLARE k INTEGER; DECLARE ok SMALLINT;
BEGIN
  SELECT e.x, e.y, e.z FROM ents e WHERE e.id = :inflictor INTO ix, iy, iz;
  -- T_RadiusDamage: findradius(inflictor.origin, damage + 40) (the middles within that sphere, the chain from the
  -- highest edict down), the points less half the distance, half on the attacker, and only where CanDamage
  FOR SELECT e.id, e.x + (e.minx + e.maxx) / 2, e.y + (e.miny + e.maxy) / 2, e.z + (e.minz + e.maxz) / 2, e.x, e.y, e.z, e.movetype, e.mtype
        FROM ents e
       WHERE e.takedamage > 0 AND e.solid <> 0 AND (:ignore IS NULL OR e.id <> :ignore)
         AND ABS(e.x + (e.minx + e.maxx) / 2 - :ix) <= :damage + 40 AND ABS(e.y + (e.miny + e.maxy) / 2 - :iy) <= :damage + 40
         AND ABS(e.z + (e.minz + e.maxz) / 2 - :iz) <= :damage + 40
       ORDER BY e.id DESC
        INTO eid, cx, cy, cz, ox, oy, oz, mt, cls
  DO
  BEGIN
    d = vlen(cx - ix, cy - iy, cz - iz);
    IF (d > damage + 40) THEN CONTINUE;
    pts = damage - 0.5e0 * d;
    IF (eid = attacker) THEN pts = pts * 0.5e0;
    IF (pts <= 0) THEN CONTINUE;
    ok = can_damage(eid, inflictor);
    IF (ok = 0) THEN CONTINUE;
    IF (cls = 'shambler') THEN pts = pts * 0.5e0;     -- shambler takes half damage from all explosions
    EXECUTE PROCEDURE t_damage(eid, inflictor, attacker, pts);
  END
END^

-- ── projectiles ─────────────────────────────────────────────────────────
CREATE OR ALTER PROCEDURE launch_spike (owner INTEGER, ox DOUBLE PRECISION, oy DOUBLE PRECISION, oz DOUBLE PRECISION,
  dx DOUBLE PRECISION, dy DOUBLE PRECISION, dz DOUBLE PRECISION, spd DOUBLE PRECISION, kind VARCHAR(16))
AS
DECLARE s INTEGER; DECLARE dl DOUBLE PRECISION;
BEGIN
  dl = vlen(dx, dy, dz);
  IF (dl = 0) THEN EXIT;
  EXECUTE PROCEDURE spawn_ent(kind, ox, oy, oz) RETURNING_VALUES s;
  EXECUTE PROCEDURE set_model(s, CASE kind WHEN 'superspike' THEN 'progs/s_spike.mdl' WHEN 'wizspike' THEN 'progs/w_spike.mdl' WHEN 'kspike' THEN 'progs/k_spike.mdl' ELSE 'progs/spike.mdl' END);
  UPDATE ents e SET e.owner_id = :owner, e.movetype = 9, e.solid = 2,
         e.vx = :dx / :dl * :spd, e.vy = :dy / :dl * :spd, e.vz = :dz / :dl * :spd,
         e.yaw = vectoyaw(:dx, :dy), e.pitch = ATAN2(:dz, vlen(:dx, :dy, 0)) * 57.29577951e0,
         e.dmg = CASE :kind WHEN 'superspike' THEN 18 ELSE 9 END,
         e.think = 'remove', e.nextthink = now_() + 6 WHERE e.id = :s;
  EXECUTE PROCEDURE link_ent(s);
END^

CREATE OR ALTER PROCEDURE launch_grenade (owner INTEGER, ox DOUBLE PRECISION, oy DOUBLE PRECISION, oz DOUBLE PRECISION,
  vx DOUBLE PRECISION, vy DOUBLE PRECISION, vz DOUBLE PRECISION, dmg INTEGER, model VARCHAR(64), fuse DOUBLE PRECISION)
AS
DECLARE s INTEGER;
BEGIN
  EXECUTE PROCEDURE spawn_ent('grenade', ox, oy, oz) RETURNING_VALUES s;
  EXECUTE PROCEDURE set_model(s, model);
  UPDATE ents e SET e.owner_id = :owner, e.movetype = 10, e.solid = 2, e.vx = :vx, e.vy = :vy, e.vz = :vz,
         e.yaw = vectoyaw(:vx, :vy), e.avel_yaw = 300, e.dmg = :dmg,
         e.think = 'grenade_explode', e.nextthink = now_() + :fuse WHERE e.id = :s;
  EXECUTE PROCEDURE link_ent(s);
END^

CREATE OR ALTER PROCEDURE launch_rocket (owner INTEGER, ox DOUBLE PRECISION, oy DOUBLE PRECISION, oz DOUBLE PRECISION,
  dx DOUBLE PRECISION, dy DOUBLE PRECISION, dz DOUBLE PRECISION, spd DOUBLE PRECISION, dmg INTEGER, model VARCHAR(64))
AS
DECLARE s INTEGER; DECLARE dl DOUBLE PRECISION;
BEGIN
  dl = vlen(dx, dy, dz);
  IF (dl = 0) THEN EXIT;
  EXECUTE PROCEDURE spawn_ent('rocket', ox, oy, oz) RETURNING_VALUES s;
  EXECUTE PROCEDURE set_model(s, model);
  UPDATE ents e SET e.owner_id = :owner, e.movetype = 9, e.solid = 2, e.effects = IIF(:model = 'progs/missile.mdl', 4, 8),
         e.vx = :dx / :dl * :spd, e.vy = :dy / :dl * :spd, e.vz = :dz / :dl * :spd,
         e.yaw = vectoyaw(:dx, :dy), e.pitch = ATAN2(:dz, vlen(:dx, :dy, 0)) * 57.29577951e0, e.dmg = :dmg,
         e.think = 'remove', e.nextthink = now_() + 5 WHERE e.id = :s;
  EXECUTE PROCEDURE link_ent(s);
END^

CREATE OR ALTER PROCEDURE grenade_explode (eid INTEGER)
AS
DECLARE own INTEGER; DECLARE dmg INTEGER; DECLARE cls VARCHAR(40);
BEGIN
  SELECT e.owner_id, e.dmg, e.classname FROM ents e WHERE e.id = :eid INTO own, dmg, cls;
  EXECUTE PROCEDURE t_radius_damage(eid, own, dmg, NULL);
  EXECUTE PROCEDURE snd(eid, 0, 'weapons/r_exp3.wav', 1, 1);
  EXECUTE PROCEDURE fx(IIF(cls = 'lavaball', 7, 2), (SELECT e.x FROM ents e WHERE e.id = :eid), (SELECT e.y FROM ents e WHERE e.id = :eid), (SELECT e.z FROM ents e WHERE e.id = :eid), 0, 0, 0, 0);
  DELETE FROM ents e WHERE e.id = :eid;
END^

-- ── touching ────────────────────────────────────────────────────────────
-- SV_Impact: e1 moved into e2 (e2 = 0 is the world)
CREATE OR ALTER PROCEDURE impact (e1 INTEGER, e2 INTEGER)
AS
DECLARE c1 VARCHAR(40); DECLARE c2 VARCHAR(40); DECLARE own INTEGER; DECLARE dmg INTEGER; DECLARE td2 SMALLINT;
DECLARE x DOUBLE PRECISION; DECLARE y DOUBLE PRECISION; DECLARE z DOUBLE PRECISION; DECLARE vz DOUBLE PRECISION; DECLARE hp2 INTEGER; DECLARE dmg2 DOUBLE PRECISION;
BEGIN
  IF (EXISTS (SELECT 1 FROM game g WHERE g.id = 1 AND g.qc_mode = 1)) THEN
  BEGIN
    EXECUTE PROCEDURE qc_impact(e1, e2);
    EXIT;
  END
  -- a dog or fiend in its leap: Dog_JumpTouch, Demon_JumpTouch
  IF (EXISTS (SELECT 1 FROM ents e WHERE e.id = :e1 AND e.attack_state = 5 AND e.mtype IN ('dog', 'demon1') AND e.health > 0)) THEN
  BEGIN
    EXECUTE PROCEDURE monster_jump_touch(e1, e2);
    EXIT;
  END
  SELECT e.classname, e.owner_id, e.dmg, e.x, e.y, e.z, e.vz FROM ents e WHERE e.id = :e1 INTO c1, own, dmg, x, y, z, vz;
  IF (e2 > 0) THEN SELECT e.classname, e.takedamage, e.health FROM ents e WHERE e.id = :e2 INTO c2, td2, hp2;
  ELSE BEGIN c2 = 'worldspawn'; td2 = 0; END
  IF (e2 = own) THEN EXIT;

  IF (c1 IN ('spike', 'superspike', 'wizspike', 'kspike')) THEN
  BEGIN
    IF (point_contents(x, y, z) = -6) THEN BEGIN DELETE FROM ents e WHERE e.id = :e1; EXIT; END   -- sky
    IF (td2 > 0 AND hp2 > 0) THEN
    BEGIN
      -- spawn_touchblood: wall_velocity's two random()s (the blood's spread), before the damage
      dmg2 = rnd(); dmg2 = rnd();
      EXECUTE PROCEDURE fx(3, x, y, z, 0, 0, 0, dmg);
      EXECUTE PROCEDURE t_damage(e2, e1, own, dmg);
    END
    ELSE
    BEGIN
      EXECUTE PROCEDURE fx(6, x, y, z, 0, 0, 0, IIF(c1 = 'superspike', 1, 0));
      EXECUTE PROCEDURE snd_at(x, y, z, 'weapons/tink1.wav', 1, 1);
    END
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'rocket') THEN
  BEGIN
    IF (point_contents(x, y, z) = -6) THEN BEGIN DELETE FROM ents e WHERE e.id = :e1; EXIT; END
    -- T_MissileTouch: 100 to 120 on what it hit, and a blast of 120 on the rest
    -- (its random() drawn whatever it hit)
    dmg2 = rnd();
    -- (100 + random() × 20 as it is, the fraction too: T_Damage takes the ceiling; half on a shambler)
    IF (td2 > 0 AND hp2 > 0) THEN EXECUTE PROCEDURE t_damage(e2, e1, own, (dmg + dmg2 * 20) * IIF((SELECT e.mtype FROM ents e WHERE e.id = :e2) = 'shambler', 0.5e0, 1));
    EXECUTE PROCEDURE t_radius_damage(e1, own, 120, e2);
    -- then the rocket backs off 8 units along its flight before it becomes the explosion: where a hit player's view
    -- kick comes from at the frame's end
    UPDATE player p SET p.dmg_x = p.dmg_x - 8 * (SELECT e.vx / NULLIF(vlen(e.vx, e.vy, e.vz), 0) FROM ents e WHERE e.id = :e1),
                        p.dmg_y = p.dmg_y - 8 * (SELECT e.vy / NULLIF(vlen(e.vx, e.vy, e.vz), 0) FROM ents e WHERE e.id = :e1),
                        p.dmg_z = p.dmg_z - 8 * (SELECT e.vz / NULLIF(vlen(e.vx, e.vy, e.vz), 0) FROM ents e WHERE e.id = :e1)
     WHERE p.id = 1 AND p.dmg_ent = :e1;
    EXECUTE PROCEDURE snd_at(x, y, z, 'weapons/r_exp3.wav', 1, 1);
    EXECUTE PROCEDURE fx(2, x, y, z, 0, 0, 0, 0);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'laser') THEN
  BEGIN
    IF (point_contents(x, y, z) = -6) THEN BEGIN DELETE FROM ents e WHERE e.id = :e1; EXIT; END
    EXECUTE PROCEDURE snd_at(x, y, z, 'enforcer/enfstop.wav', 1, 1);
    IF (td2 > 0 AND hp2 > 0) THEN
    BEGIN
      EXECUTE PROCEDURE fx(3, x, y, z, 0, 0, 0, 15);
      EXECUTE PROCEDURE t_damage(e2, e1, own, 15);
    END
    ELSE EXECUTE PROCEDURE fx(1, x, y, z, 0, 0, 0, 0);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'voreball') THEN
  BEGIN
    IF (td2 > 0 AND hp2 > 0) THEN EXECUTE PROCEDURE t_damage(e2, e1, own, 40);
    EXECUTE PROCEDURE t_radius_damage(e1, own, 40, e2);
    EXECUTE PROCEDURE snd_at(x, y, z, 'weapons/r_exp3.wav', 1, 1);
    EXECUTE PROCEDURE fx(2, x, y, z, 0, 0, 0, 0);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'lavaball') THEN
  BEGIN
    IF (td2 > 0 AND hp2 > 0) THEN EXECUTE PROCEDURE t_damage(e2, e1, own, dmg);
    EXECUTE PROCEDURE t_radius_damage(e1, own, dmg, e2);
    EXECUTE PROCEDURE snd_at(x, y, z, 'weapons/r_exp3.wav', 1, 1);
    EXECUTE PROCEDURE fx(7, x, y, z, 0, 0, 0, 0);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'fireball') THEN
  BEGIN
    IF (td2 > 0 AND hp2 > 0) THEN EXECUTE PROCEDURE t_damage(e2, e1, e1, 20);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'grenade') THEN
  BEGIN
    IF (td2 = 2 AND hp2 > 0) THEN EXECUTE PROCEDURE grenade_explode(e1);
    ELSE EXECUTE PROCEDURE snd_at(x, y, z, 'weapons/bounce.wav', 1, 1);
  END
  ELSE IF (c1 = 'zombie_gib') THEN
  BEGIN
    IF (td2 > 0 AND hp2 > 0) THEN
    BEGIN
      EXECUTE PROCEDURE t_damage(e2, e1, own, 10);
      EXECUTE PROCEDURE snd_at(x, y, z, 'zombie/z_hit.wav', 1, 1);
    END
    ELSE EXECUTE PROCEDURE snd_at(x, y, z, 'zombie/z_miss.wav', 1, 1);
    DELETE FROM ents e WHERE e.id = :e1;
  END
  ELSE IF (c1 = 'player' AND c2 = 'func_door') THEN EXECUTE PROCEDURE door_touch(e2, e1);
  ELSE IF (c1 = 'player' AND c2 = 'func_door_secret') THEN
  BEGIN
    IF (EXISTS (SELECT 1 FROM ents e WHERE e.id = :e2 AND (e.targetname IS NULL OR e.targetname = '') AND e.max_health = 0)) THEN
      EXECUTE PROCEDURE secret_use(e2);
    ELSE IF (EXISTS (SELECT 1 FROM ents e WHERE e.id = :e2 AND e.message IS NOT NULL AND e.attack_finished < now_())) THEN
    BEGIN
      EXECUTE PROCEDURE cprint((SELECT e.message FROM ents e WHERE e.id = :e2));
      EXECUTE PROCEDURE snd(e1, 2, 'misc/talk.wav', 1, 1);
      UPDATE ents e SET e.attack_finished = now_() + 2 WHERE e.id = :e2;
    END
  END
  ELSE IF (c1 = 'player' AND c2 = 'func_button') THEN
  BEGIN
    IF (EXISTS (SELECT 1 FROM ents e WHERE e.id = :e2 AND e.max_health = 0)) THEN EXECUTE PROCEDURE button_fire(e2, e1);
  END
  ELSE IF (c1 = 'player' AND c2 = 'misc_explobox') THEN BEGIN END
END^

SET TERM ; ^
